import { customComponentRef } from './consts';
import { getCustomComponentTraits } from './customComponentTraits';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const { projectId, labelCustomComponent, version } = opts;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  domc.addType(customComponentRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-alarm"></i>',
          'custom-name': 'Custom Component',
          projectId: projectId,
          version: version,
          showHtmlContent: true,
          customComponentUuid: '',
          getPageCollection: false,
          script: function () {
            const customComponentUuid = '{[ customComponentUuid ]}';
            const projectId = '{[ projectId ]}';
            const version = '{[ version ]}';
            let showHtmlContent = '{[ showHtmlContent ]}';
            let getPageCollection = '{[ getPageCollection ]}';
            if (customComponentUuid && customComponentUuid.length > 0) {
              const headers = {
                'Content-Type': 'application/json',
                'x-project-id': projectId,
              };
              const customComponentEl = this;
              const identifyType = customComponentEl.getAttribute('data-gjs-type');
              let showContent = false;
              let serverUrl = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/`;
              if (!identifyType) {
                serverUrl = getBackendServerUrl();
                showContent = true;
              }
              let customComponentUUID = customComponentUuid;
              console.log('🚀 customComponentUuid:', customComponentUUID);
              console.log('7');
              let url = `${serverUrl}custom-component/${customComponentUUID}`;
              const extra = {
                method: 'GET',
                headers,
              };
              showHtmlContent = showHtmlContent.trim();
              getPageCollection = getPageCollection.trim();
              if (showContent || showHtmlContent === true || showHtmlContent === 'true') {
                console.log('🚀 ~ customComponentUuid ~ url show full content:', url);
                fetch(url, extra)
                  .then((response) => {
                    return response.json();
                  })
                  .then((res) => {
                    if (res) {
                      const {
                        name,
                        content: { htmlContent },
                      } = res;
                      customComponentEl.innerHTML = '';
                      customComponentEl.innerHTML = htmlContent ? htmlContent : name;
                      if (typeof renderCustomComponentIntoElem !== 'undefined') {
                        renderCustomComponentIntoElem(res, customComponentEl);
                      }
                    }
                  });
              } else {
                console.log('🚀 ~ customComponentUuid ~ url only show name:', url);
                fetch(url, extra)
                  .then((response) => {
                    return response.json();
                  })
                  .then((res) => {
                    customComponentEl.innerHTML = '';
                    customComponentEl.innerHTML = res['name'];
                  });
              }
            }
          },
        },
        init() {
          getCustomComponentTraits(projectId, version, labelCustomComponent).then((res) => {
            if (res) {
              this.addTrait(res, { at: 0 });
              this.addTrait(
                {
                  type: 'checkbox',
                  label: 'Show Custom Component Content',
                  name: 'showHtmlContent',
                  changeProp: 1,
                },
                { at: 1 },
              );
              this.addTrait(
                {
                  type: 'checkbox',
                  label: 'Page Collection',
                  name: 'getPageCollection',
                  changeProp: 1,
                },
                { at: 2 },
              );
            }
          });
          this.on('change:customComponentUuid', this.handleCustomComponentChange);
          this.on('change:getPageCollection', this.handleGetPageCollection);
        },
        async handleCustomComponentChange() {
          const attrs = this.getAttributes();
          const customComponentUuid = this.get('customComponentUuid');
          attrs['data-custom-component-id'] = customComponentUuid;
          this.setAttributes(attrs);
        },
        async handleGetPageCollection() {
          const attrs = this.getAttributes();
          const getPageCollection = this.get('getPageCollection');
          attrs['get-page-collection'] = `${getPageCollection}`;
          this.setAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === customComponentRef)
            return { type: customComponentRef };
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:customComponentUuid', this.updateScript);
      },
    }),
  });
}
